import { FieldType } from 'modules/domains';
import {
  isBooleanFieldType,
  isNumberFieldType,
  isDateFieldType,
  isStringFieldType,
} from 'modules/domains/segmentation/utils';
import { BooleanComparator, DateComparator, NumericComparator, StringComparator } from '../domain';

export const getDefaultComparator = (type: FieldType) => {
  if (isBooleanFieldType(type)) return BooleanComparator.Equals;
  if (isNumberFieldType(type)) return NumericComparator.Equals;
  if (isDateFieldType(type)) return DateComparator.Exactly;
  if (isStringFieldType(type)) return StringComparator.Equals;
  else throw new Error("can't get default comparator");
};
